import gql from 'graphql-tag';

export const updateListGql = gql`
  mutation (
    $inst_id: String!
    $account_id: String!
    $id: String!
    $shared: Boolean!
  ) {
    listUpdate(
      instId: $inst_id
      accountId: $account_id
      id: $id
      shared: $shared
    ) {
      data {
        updatedAt
        id
        accountId
        system
        shared
        name
        deletedAt
        orderBy
        attributes
      }
      message
      code
    }
  }
`;

export const listSharedValueGql = gql`
  query ($inst_id: String!, $account_id: String!, $id: String!) {
    list(instId: $inst_id, accountId: $account_id, id: $id) {
      shared
    }
  }
`;
